import React from "react";
import { useLocation } from "react-router-dom";
import logo from "../../../images/logo/to-logo.svg";
import "./EventAttendanceSuccess.css";

const EventAttendanceSuccess = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const eventName = query.get("event_name") || "the event";
    const email = query.get("email") || "Guest";

    return (
        <div className="attendance-success-wrapper">
            <div className="attendance-success-card">
                <img src={logo} alt="Logo" className="attendance-success-logo" />
                <h1 className="attendance-success-title">🎉 You're All Set!</h1>
                <p className="attendance-success-message">
                    Hi <strong>{email}</strong>, your attendance for <strong>"{eventName}"</strong> has been successfully confirmed.
                </p>
                <p className="attendance-success-thankyou">
                    We're excited to have you with us. Thank you for confirming!
                </p>
            </div>
        </div>
    );
};

export default EventAttendanceSuccess;
